// import React from 'react'

// const PrivacyPolicy = () => {
//   return (
//     <div>
//       <div className="row mt-5 p-4">
//         <div className="col-md-10 offset-md-1">
//           <h1 style={{ color: "#073f41", textAlign: "center" }}>Privacy Policy</h1>
//           <p className="mt-5" style={{ fontSize: 20 }}>
//             At Mohit-Brothers (accessible at{" "}
//             <a href="Maa kamakhya puja seva.com/" target="_blank">
//               Maa kamakhya puja seva.com/
//             </a>
//             ), we value your privacy and are committed to protecting your personal
//             information. This Privacy Policy explains how we collect, use, and share
//             data when you visit our website or use our services.
//           </p>
//           <h4 className="mt-4">Information We Collect</h4>
//           <ul>
//             <li style={{ fontSize: 20, color: "black" }}>
//               Personal Details: Name, email, phone, and shipping address collected
//               during account creation or purchase.
//             </li>
//             <li style={{ fontSize: 20, color: "black" }}>
//               Order Information: Product purchases and payment details.
//             </li>
//             <li style={{ fontSize: 20, color: "black" }}>
//               Browsing Data: IP address, device type, and browsing habits via cookies.
//             </li>
//           </ul>
//           <h4 className="mt-4">Use of Information</h4>
//           <p style={{ fontSize: 20 }}>
//             We use your data to process orders, improve your experience, provide
//             support, and deliver promotional content tailored to you.
//           </p>
//           <h4 className="mt-4">Cookies</h4>
//           <p style={{ fontSize: 20 }}>
//             Cookies personalize your shopping experience. Adjust your browser settings
//             to manage or disable cookies.
//           </p>
//           <h4 className="mt-4">Third-Party Services</h4>
//           <p style={{ fontSize: 20 }}>
//             We may share data with trusted partners (e.g., payment gateways) to
//             complete transactions securely.
//           </p>
//           <h4 className="mt-4">Your Rights</h4>
//           <p style={{ fontSize: 20 }}>
//             You may access, correct, or delete your data and opt out of marketing
//             communications by contacting us.
//           </p>
//           <h4 className="mt-4">Updates to This Policy</h4>
//           <p style={{ fontSize: 20 }}>
//             We may revise this policy to reflect new practices. Updates will be posted
//             here.
//           </p>
//           <h4 className="mt-4">Contact Us</h4>
//           <p style={{ fontSize: 20 }}>
//             If you have any questions about this Privacy Policy or how we handle your
//             data, please contact us at <a href="">Maa kamakhya puja seva.com</a>.
//           </p>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default PrivacyPolicy







import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="row  p-4">
        <div className="col-md-10 offset-md-1">
          <h1 style={{ color: "#073f41", textAlign: "center" }}>
            Privacy Policy
          </h1>
          <h2>
            Ensuring the safety and confidentiality of your spiritual journey.
          </h2>
          <p style={{ fontSize: 20 }}>
            We collect and store your personal details, such as name, phone,
            number, and payment informatio, to facilitate pooja bookings. Your
            data is protected and not shared with third parties, except as
            required by law. We implement strong security measures to ensure
            your information remains confidential and is used only for
            booking-related purposes.
          </p>
          <h4 className="mt-4">Information Collected:</h4>
          <ul>
            <li style={{ fontSize: 20, color: "black" }}>Name</li>
            <li style={{ fontSize: 20, color: "black" }}>Phone Number</li>

            <li style={{ fontSize: 20, color: "black" }}>mail Address</li>

            <li style={{ fontSize: 20, color: "black" }}>Payment Details</li>
          </ul>
          <h4 className="mt-4"> Usage of Information :</h4>
          <ul>
            <li style={{ fontSize: 20, color: "black" }}>
              Confirm and manage your pooja bookings
            </li>
            <li style={{ fontSize: 20, color: "black" }}>
              Send WhatsApp or SMS notifications
            </li>
            <li style={{ fontSize: 20, color: "black" }}>
              Securely process your payments
            </li>
          </ul>
          <h4 className="mt-4"> Managing Cookies</h4>
          <ul>
            <li style={{ fontSize: 20, color: "black" }}>
              You can manage or disable cookies through your browser settings.
            </li>

            <li style={{ fontSize: 20, color: "black" }}>
              Disabling cookies may affect some features or functionality of the
              website.
            </li>
          </ul>

          <h4 className="mt-4"> Third-Party Sharing</h4>
          <p style={{ fontSize: 20, color: "black"}}>
            We do not share your data except in the following cases:
          </p>

          <ul>
            <li style={{ fontSize: 20, color: "black" }}>
              With secure payment gateways for processing payments
            </li>
            <li style={{ fontSize: 20, color: "black" }}>
              When required by legal regulations
            </li>
          </ul>

          <h4 className="mt-4">Data Protection</h4>
          <p style={{ fontSize: 20, color: "black", marginTop: "10px" }}>
            Your personal data is stored securely using encryption and secure
            servers. We follow industry-standard practices to prevent
            unauthorized access, ensuring your sacred journey remains protected.
          </p>

          <li style={{ fontSize: 20, color: "black" }}>
            With secure payment gateways for processing payments
          </li>
          <li style={{ fontSize: 20, color: "black" }}>
            When required by legal regulations
          </li>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;




